export const TimelineBar = ({ compact = false, testid = "timeline-bar" }) => {
    return (
        <div data-testid={testid} className="w-full">
            <div className={`flex w-full ${compact ? "h-1.5" : "h-2.5"}`}>
                <div className="w-[25%] bg-[#f5f5f0]" />
                <div className="w-[50%] bg-[#262626]" />
                <div className="w-[25%] bg-[#ff2a2a]" />
            </div>
            {!compact && (
                <div className="flex w-full justify-between mt-1 font-mono-d8 text-[10px] tracking-[0.18em] text-[#8a8a8a] uppercase">
                    <span>0:00</span>
                    <span className="ml-[23%]">0:02</span>
                    <span className="ml-[23%]">0:06</span>
                    <span>0:08</span>
                </div>
            )}
        </div>
    );
};

export default TimelineBar;
